import React from 'react';
import { Box, Button, Typography, IconButton, Tooltip, Popover, InputAdornment, Avatar } from '@mui/material';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FormInputBox from '../../../common-components/form-items/FormInputBox';
import useConnectUserHanlder from '../hooks/useConnectUserHanlder';
import { useSideBarHandler } from '../hooks/useSideBarHandler';

export default function ConnectUser() {
  const { control, handleSubmit, isLoading, connectedUser, handleDisconnect } = useConnectUserHanlder();
  const { isSidebarOpen } = useSideBarHandler();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);
  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const Form = connectedUser ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1,
        borderRadius: 1,
        bgcolor: 'background.paper',
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Avatar sx={{ width: 32, height: 32 }}>{(connectedUser.name || connectedUser.email || '?').charAt(0).toUpperCase()}</Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
          {connectedUser.name || connectedUser.email}
        </Typography>
        <Typography variant="caption" color="success.main" sx={{ display: 'block' }}>
          Connected
        </Typography>
      </Box>
      <Button variant="outlined" color="error" size="small" onClick={handleDisconnect} startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}>
        Delete
      </Button>
    </Box>
  ) : (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
      <Typography variant="caption" color="text.secondary">
        Connect user
      </Typography>
      <Box sx={{ mt: 0.5 }}>
        <FormInputBox
          size="small"
          name="email"
          control={control}
          type="email"
          placeholder="Email address"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Button type="submit" variant="contained" size="small" disabled={isLoading} loading={isLoading}>
                  Connect
                </Button>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </form>
  );

  if (isSidebarOpen) {
    return <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>{Form}</Box>;
  }

  return (
    <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
      <Tooltip title="Connect user">
        <IconButton size="small" onClick={handleIconClick}>
          <PersonAddAltIcon />
        </IconButton>
      </Tooltip>
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }} sx={{ '& .MuiPaper-root': { p: 2, width: 300 } }}>
        {Form}
      </Popover>
    </Box>
  );
}
